module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.7d59ee8.ttf";